<template>
  <CompanyPolicy></CompanyPolicy>
  <div class="col-xxl-12" >

    <!--begin::code of conduct-->
    <div :class="widgetClasses" class="card" >
      <div class="card-body py-3">
        <h3 class="card-title align-items-start flex-column mb-5 mt-5">
          <span class="card-label fw-bolder fs-3 mb-1">CODE OF CONDUCT AND ETHICAL STANDARDS</span>
        </h3>
        <p>ALLIANCE IN MOTION GLOBAL Inc. CODE OF CONDUCT AND ETHICAL STANDARDS</p>

        <p>CODE NO. 1</p>
        <p>All members shall at all times, remain loyal to the company and its policies being issued from time to time by not committing acts which are not limited to joining, representing, associating, sponsoring, recruiting, conspiring in any mode and form for the benefit or advantage directly or indirectly of competing companies, business groups, partnership or individual, either locally or abroad, neither introduce, present sell, promote, offer, in any form nor manner their products, services, businesses, marketing programs and plans or a combination thereof, whether tangible or intangible.</p>
        
        <p>CODE NO. 2</p>
        <p>All members are strictly enjoined to be honest in all conducts and dealings locally and abroad by not making, agitating, encouraging written or oral derogatory or defamatory remarks, utterances or any statement in any form that discredit and disrepute the company, its centers or any of its service branch, which at the same time malign the credibility of its officers and employees.</p> 
        <p>CODE NO. 3</p>
        <p>All members are strictly enjoined to be professionals in all acts and bearings, dealings or transactions by not committing any false statements, such as, but not limited to misrepresentation, exaggeration, disinformation, vane promises, introducing spurious products or services, or circumventing the marketing plans or programs of the company that contravene the tenor and purposes thereof.</p>
        
        <p>CODE NO. 4</p>
        <p>All members are strictly enjoined to be honest and credible in all deeds by not committing acts against the company or fellow members which are but not limited to: a) imitating or counterfeiting any handwriting, or signature; b) causing it to appear that a member has participated in any act or activity when he did not in fact so participate; c) alluding or pointing to members who have participated in an act, activity or statements other than those made by them; d) inserting untruthful statements in a narration of facts such as those in the affidavit, deed and other documents similar thereto; e) altering true dates; f) making any alteration or intercalation in a genuine document which alters or changes its meaning; f) issuing in an authenticated form a document purporting to be a copy of an original document when no such original actually exists;</p>  
        
        <p>CODE NO. 5</p>
        <p>All members are strictly enjoined to observe humility and respect towards fellow members, officers and employees of the company, by not committing directly or indirectly any inimical or malevolent acts which are but not limited to rudeness, disrespect and discourtesy.</p>
        
        <p>CODE NO. 6</p>
        <p>All members are strictly enjoined to have sense of equality and sincerity toward fellow members by observing the 6-month rule, wherein a fellow member has 6 months from presentation of the marketing plan or program of the company and signing of any document towards membership by the prospective member, within which fellow member shall not interfere, intervene or alienate said prospective member at the prejudice of the first member.</p>
        <p>CODE NO. 7</p>
        <p>All members are strictly enjoined to be at all times clothe with integrity and sense of oneness and unity, by not committing any immoral act or conduct which tends to debase company policies, transgress decency, morals and good behavior, while inside or within the company premises, its centers or service branch, neither practice cross lining that obstructs oneness and unity between husband and wife nor commit acts that circumvent the same.</p>
        
          <p>(AS TO IMMORAL ACTS OR CONDUCTS)</p>
          <p>(AS TO CROSS LINING)</p>
        
        <p>CODE NO. 8</p>
        <p>All members are strictly enjoined not to commit any fraudulent act or false pretenses to the prejudice directly or indirectly of the company or fellow member by not committing acts which are not limited to: a) using a fictitious name, or dummy, or by means of other similar deceits purportedly to obtain personal gain and interest; b) by altering the quality, fineness or weight of the product or any product pertaining to the business of the company; c) issuing  a check to a fellow member or to the company or incurring obligation to both, when it has no funds or insufficient to  cover the amount of the check or evading the performance thereof or any obligation after demand.</p>
        
        <p>Depending on the gravity of violation as determined by the ad-hoc committee </p>
        <p>*written reprimand</p>
        <p>*Six (6) months deactivation of all the accounts with forfeiture in favor of the company of all the benefits, privileges, commissions and other re numerations either monetary or in kind, which accrued at the time of the commission of the violation.</p>
        <p>*Perpetual deactivation of all the accounts which carries with it the forfeiture of all benefits, privileges, commissions and other renumerations either monetary or in kind in favor of the company, which accrued at the time of the commission of the violation.</p>
        <br/>
      </div>
    </div>
    <!--begin::code of conduct-->

    <br/>

    <!--begin::terms and conditions-->
    <div :class="widgetClasses" class="card" >
      <div class="card-body py-3">
        <h3 class="card-title align-items-start flex-column mb-5 mt-5">
          <span class="card-label fw-bolder fs-3 mb-1">TERMS AND CONDITIONS</span>
        </h3>
        <p>ALLIANCE IN MOTION GLOBAL INC. TERMS AND CONDITIONS</p>
                    
        <p>1. Any person of legal age (18 years of age and above), corporation, partnership or any legal entity may apply and become an Aim Global Distributor by;</p>
        <p>2. As an Aim Global Inc Distributor, he/she/it can now engage in the direct selling of all Aim Global Inc.'s in-house products and services, (e.g.  health and wellness commodities) and shall be entitled to corresponding commissions, rebates, discounts and privileges given by the company;</p>
        <p>3. An Aim Global Distributor must observe the company's rules, regulations and its Code of Ethics;</p>
        <p>4. There shall be no employer and employee relationship between Aim Global Inc.  and its Distributors;</p>
        <p>5. Aim Global Inc. is authorized to deduct the corresponding taxes derived from the sales and commissions or rebates of a Distributor;</p>
        <p>6.  Aim Global Inc. shall not be responsible for any misrepresentation made by its Distributors;</p>
        <p>7. The company reserves the right to modify, revise and update its existing policies and business plan for the best interest of Aim Global Inc. and its Distributors members without prior notice;</p>
        <p>8. One price policy;</p>
        <p>9. New Product Policy as an Aim Global Distributor to have rebates on the new product, he/ she/ it must buy the new product on the month of its release this is on top of the personal monthly maintenance, but on the following month will return to the original personal monthly maintenance.</p>
        <br/>
      </div>
    </div>
    <!--end::terms and conditions-->


    <br/>

    <!--begin::notice to all distributors -->
    <div :class="widgetClasses" class="card" >
      <div class="card-body py-3">
        <h3 class="card-title align-items-start flex-column mb-5 mt-5">
          <span class="card-label fw-bolder fs-3 mb-1">NOTICE TO ALL DISTRIBUTORS</span>
        </h3>
        <p align="justify">
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					We write to you in behalf of our client,  Alliance In Motion Global Inc. (hereafter the Company).</p>
	
					<p align="justify">
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						The Company informed us that various retail stores have been openly distributing and selling AIM Global products without authority
						and below the authorized prices. Some AIM Global products also end up being sold on various online sites, such as Lazada, OLX, EBay,
						Amazon, Metrodeal and other similar forums. As it turned out, these products are being directly supplied by  AIM Global Distributors
						themselves who unload the products to these retail stores and online sites at very low prices, in violation of Company policy. </p>
					<p align="justify">
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						As you are very much aware, it is the policy of the Company to distribute and sell its
					products only through you, the authorized Distributors; as the chosen Distributors, you can only
					sell   the   products   at   authorized   prices   in   accordance   with   the   terms  and  conditions   of   your
					distribution contract. Selling the products below the authorized prices is prohibited.   Selling the
					products  to  retail  stores,   whether  traditional   or   online,  is  also  prohibited. This   is  intended  to
					maintain the quality and integrity of the product, and not to mention to preserve the exclusivity of
					the distribution.</p> 
					
					<p align="justify">
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					It is unfortunate, however, that there are Distributors who deliberately violate the policy.
					
					This Notice shall, therefore, serve as a stern warning and reminder to all these erring
					Distributors that their continuous violation shall result in the outright termination of their respective
					distributorship contracts and the forfeiture of all of their commissions and benefits. In addition,
					they shall be subjected to various legal proceedings, including damage suits and criminal cases
					for estafa.</p> 
					
					<p align="justify">
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					Be constantly reminded of your undertaking below to fulfill your duties and responsibilities
					as a Distributor and to comply with all of the relevant Company policies and regulations governing
					Distributors.</p>
					
					<p align="justify">
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					You are hereby directed to relay to the Company  or to the undersigned any relevant
					information regarding the matter in order to stop these unauthorized sale and distribution and
					other related violations. </p>
					
					<p>Your cooperation is a must.</p>
        <br/>
      </div>
    </div>
    <!--end::notice to all distributors -->


    <br/>
    <!--begin::you must agree -->
    <div :class="widgetClasses" class="card">
      <div class="card-body py-3">
        <h3 class="card-title align-items-start flex-column mb-5 mt-5">
          <span class="card-label fw-bolder fs-3 mb-1">ALLIANCE IN MOTION GLOBAL, INC. TERMS AND CONDITIONS FOR DISTRIBUTORS
</span>
        </h3>
        <p>1.	Any person of legal age (18 years old and above), corporation, partnership or legal entity may apply and become an AIM Global Distributor;</p>


        <p>2.	ON FAMILIARIZATION OF THE COMPANY POLICY. Each Distributor, upon signing the application form or registering on the Distributors’ website, agrees to abide by AIM Global’s Policies. The placing of order for products with AIM Global is a reaffirmation of such commitment to abide by the company policies.</p>

        <p>3.	AIM Global Distributors shall remain loyal to the company and its policies and are not allowed to join any other Multilevel Marketing (MLM) companies while they are an active member of AIM Global, Inc.</p>

        <p>4.	ON INTENTIONAL DISREGARD OF COMPANY POLICIES. Intentional acts of omission and disregard for company policies by a Distributor shall be dealt with accordingly, which may result to termination of membership and/or legal action for damages.</p>

        <p>5.	As an AIM Global Distributor he/she/it can now engage in the direct selling of all AIM Global products and services (e.g. Health and wellness commodities) and shall be entitled to corresponding commissions, rebates discounts and privileges given by the company. Resigned or terminated Distributors, however, are no longer entitled to avail of the aforementioned commissions and benefits.</p>

        <p>6.	ONE PRICE POLICY. Selling of Global Package and/or products above or below the approved price is STRICTLY PROHIBITED. Violation of which will mean termination of distributorship.       </p>

        <p>7.	RELATIONSHIP AND REPRESENTATION. AIM Global members are considered “Independent Distributors” and as such, there shall be no employer-employee relationship between them and AIM Global, Inc. AIM Global, Inc. shall not be responsible for any misrepresentation made by its Distributors.</p>

        <p>8.	AIM Global, Inc. is authorized to deduct corresponding taxes derived from the sales, commissions and/or rebates of a Distributor.</p>

        <p>9.	ON PROXY DISTRIBUTORSHIP. A Distributorship, and any resulting group, created or operated by proxy, whether intentionally or inadvertently, is not allowed and shall be adjusted for compliance with company policies.</p>

        <p>10.	NEW PRODUCT POLICY. For AIM Global Distributors to earn rebates on a new product he/she/it must buy the new product on the month of its release. This is on top of the personal monthly maintenance. But on the following month will return to the original personal monthly maintenance.</p>

        <p>11.	All AIM Global products shall NOT be sold in any retail stores such as Pharmacies, Drug Stores, PX Shops, Grocery Stores, Supermarkets and the like as this will directly compete with the Business Center Office (BCO) and satellite offices nationwide.</p>

        <p>12.	ON PRODUCT CODES. All product codes are valid for 60 days, product codes beyond 60 days will automatically expire and it is not replaceable. It is the distributor’s responsibility to monitor the expiration of the product codes.</p>

        <p>13.	The company reserves the right to modify, revise and update its existing policies and business plan for the best interest of AIM Global, Inc. and its Distributors without prior notice.</p>

        <p>14.	ON PROMOTIONAL MATERIALS. Distributors agree not to use any written, printed, recorded or any other materials (other than those approved by AIM Management) in advertising, promoting or describing the products or AIM Marketing Program, or in any other manner, any material, which has not been approved by AIM Management before being disseminated, published or displayed. The use, production or sale of any sales materials created by a Distributor which has no prior written approval from AIM Management is strictly prohibited.</p>

        <p>15.	MULTIPLE HEADS/SLOTS. AIM Global Distributors shall be allowed to purchase only up to the maximum allowable product packages.</p>

        <p>16.	ON RE-SELLING OF ACCOUNTS/HEADS/SLOTS. Re-selling of accounts/heads/slots of a Distributor is strictly NOT ALLOWED to any individual whether he or she belongs to the same group, cross line, up line, down line, relative or otherwise. This is prohibited under DTI regulations.</p>

        <p>17.	ON TRANSFERING TO ANOTHER GROUP. It is strictly prohibited to engage in any activity that involves the soliciting of any Distributor to transfer/move to a different group by making offers such as, but not limited to, free slots, marketing support, financial support, etc.</p>

        <p>18.	PROHIBITION ON BONUS BUYING. Bonus Buying includes:</p>

        <p>a.	Registration of individuals without the knowledge of and/or execution of an Independent Distributor Application Form by such individual;</p>
        <p>b.	The fraudulent registration of an individual as a Distributor;</p>
        <p>c.	The registration or attempted registration of non-existent individuals as Distributors to qualify for bonus or commissions;</p>
        <p>d.	Any other ways or mechanisms by which strategic purchases are made to maximize commissions or bonuses when a Distributor does not have a bona fide use for the products purchased.</p>

        <p>PROHIBITION ON BUY-INS. Buy-In is the purchase of products exceeding the amount allowed to meet immediate sales needs. Such act is not permitted and will lead to the termination of the Distributors’ account.</p>

        <p>To discourage any Distributor from Bonus Buying and Buy-In Prohibitions the Company reserves the right to pay or not to pay any bonus or commission to the Distributor and up lines who benefited from such transactions. Distributor/s who took part in the Bonus Buying and/or Buy-In will be dealt with severely, which may include termination and/or legal action for damages.</p>

        <p>19.	RE-SPONSORING POLICY. Except for authorized re-sponsoring, it is against company policy for any distributor to change sponsors. AIM will only consider the first valid registration and any subsequent applications or registrations will not be allowed. </p>


        <p>20.	ON RE-INVENTING THE MARKETING SCHEME.  The Hybrid Marketing Plan of Alliance In Motion Global, Inc. is a combination of Binary, Uni level and Stair step plan, it is a sharing or selling of products and sharing or selling the business plan to prospective client and the Global Package. It  is NOT an INVESTMENT SCHEME where in, it will be presented to people who will be called as INVESTORS and in return get a huge percentage as interest while doing nothing upon placing a huge sum of money as their INVESTMENT, This is NOT the scheme of Alliance In Motion Global, Inc. Any individual or group who will present, join, promote or has a connection in any way directly or indirectly will  be dealt with severely, which may include termination and/or legal action for damages. The company will NOT be held liable if a distributor/s joins the said unauthorized investment even if he/she does’nt know the policy. Due diligence is expected on each distributor/individual if he/she is being asked to pay more than the approved Product Package.</p>

        <p>21.	ON TRANSFERRING OF ACCOUNT. Account/s can only be transferred if the owner of the account passed away and it is transferrable only to immediate legal beneficiary.</p>

        <p>22.	IN CASE OF VIOLATION. An AIM Global Distributor must observe the company’s rules, regulations and Code of Ethics. Violation of which will mean automatic deactivation, suspension or termination of account. After deactivation of an account, the Distributor is given two (2) months to clarify the issues pertaining to the deactivation by reporting to the management in person. Non-compliance will lead to the permanent deactivation of the account.</p>

        <p>NOTE: TERMS & CONDITIONS and CODE OF CONDUCT MAY CHANGE WITHOUT PRIOR NOTICE.</p>








      </div>
    </div>


    <br/>
    <!--begin::you must agree -->
    <div :class="widgetClasses" class="card">
      <div class="card-body py-3">
        <h3 class="card-title align-items-start flex-column mb-5 mt-5">
          <span class="card-label fw-bolder fs-3 mb-1">You must agree to proceed...</span>
        </h3>
        <div class="row mb-5 mt-5" v-if="false">
            <label class="form-check-label">
							<span class="form-check-sign"></span>
				                                 I Agree with the Code of Conduct and Ethical Standards
						</label>
        </div>

        <div class="row mb-5 mt-5" v-if="false">
            <label class="form-check-label">
						<span class="form-check-sign"></span>
						I hereby certify that all the information above are true and correct to the best of my knowledge. Further, I hereby abide to the Aim Global Inc. Distributor Agreement, and I also acknowledge that any violation of the company policies and procedures may result in the revocation and/or termination of my Membership and be liable for possible criminal and/or civil charges in the proper forum.
						</label>
        </div>


        <div class="row mb-5 mt-5" v-if="false">
            <label class="form-check-label">
						<span class="form-check-sign"></span>
						I hereby undertake to fulfill my duties and responsibilities as a Distributor of AIM Global
and comply with all of the relevant Company policies and regulations governing Distributors.   I
shall not sell AIM Global products to retail stores, whether traditional or online.  I shall not sell AIM
Global   products   below   the   authorized   prices.   I   shall   ensure   that   all   selling   and   distribution
activities that I undertake do not violate Company policies and regulations.
						</label>
        </div>


        <div class="row mb-5 mt-5" v-if="false">
            <label class="form-check-label">
						<span class="form-check-sign"></span>
						I shall immediately report to AIM Global or its counsel any information that I have or may
have  about  any  unauthorized   sale and   distribution  of  AIM Global  products and   other related
violations.
						</label>
        </div>

        <div class="row mb-5 mt-5">
            <label class="form-check-label col-md-10">
						<input class="form-check-input" id="checkbox4" type="checkbox" v-on:click="checkBoxValidator($event);">
						<span class="form-check-sign"></span>
						I have read the ALLIANCE IN MOTION GLOBAL, INC. TERMS AND CONDITIONS FOR DISTRIBUTORS. I agree and I want to proceed!
						</label>

        </div>

        <div class="row mb-5 mt-5" v-if="proceedBtnDisabled">
            <a href="#" class="btn btn-sm btn-secondary min-w-100px" data-bs-toggle="modal" style="cursor: default !important;"> Proceed </a>
        </div>
        <div class="row mb-5 mt-5" v-if="!proceedBtnDisabled">
            <a href="#" class="btn btn-sm btn-info min-w-100px" data-bs-toggle="modal" v-on:click="agreeTocompanyPolicy();" > Proceed </a>
        </div>


        
        
        <br/>
      </div>
    </div>
    <!--end::you must agree -->



  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { getCurrentUser, setCurrentUser} from "@/utils/index"
import {companyPolicyAgree}  from "@/api/companypolicy";
import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue"

export default defineComponent({
  name: "companypolicymain",
  components: {
    CompanyPolicy
  },
  data() {
    return {
      accountlist: [],
      currentUsid: "",
      proceedBtnDisabled : true
    }
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Company Policy");
    });
  }, 
  methods: {
      async checkBoxValidator(event){
        if (event.target.checked) {
          this.proceedBtnDisabled = false;
        } else {
          this.proceedBtnDisabled = true;
        }
      },
      async agreeTocompanyPolicy(){
        const response = await companyPolicyAgree();

        if(response != null){
          if(localStorage.getItem("pt") === 'ovi'){
            this.$router.push('/dashboard/reminderspage') ;
          } else if(localStorage.getItem("pt") === 'ecp' || localStorage.getItem("pt") === 'edp'){
            this.$router.push('/dashboardecp/reminderspage') ;
          }
            return; 
        } 
      }
  },
  mounted() {
    
      let user = getCurrentUser();
      this.currentUsid = user.usid;
      
  }
});
</script>
